class TabbedCollectionSlider extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
  }

  connectedCallback() {
    this.slidersList = this.querySelectorAll(".tabbed-collections-slider");
    this.navControlsList = this.querySelectorAll(".collection-slider-nav");
    this.topTabs = this.querySelectorAll(".top-tab-btn");
    this.sideTabs = this.querySelectorAll(".side-tab-btn");

    this.topTabs?.forEach((tab, i) => {
      tab.addEventListener("click", () => this.handleTabClick(i));
    });

    this.sideTabs?.forEach((tab, i) => {
      tab.addEventListener("click", () => this.handleTabClick(i));
    });
  }

  handleTabClick(index) {
    if (
      !this.slidersList[index] ||
      !this.navControlsList[index] ||
      !this.slidersList[index].classList.contains("visually-hidden")
    )
      return;

    this.topTabs.forEach((tab, i) => {
      index !== i
        ? tab.classList.remove("selected")
        : tab.classList.add("selected");
    });

    this.sideTabs.forEach((tab, i) => {
      index !== i
        ? tab.classList.remove("selected")
        : tab.classList.add("selected");
    });

    this.setSliderControls(index);
  }

  setSliderControls(index) {
    this.slidersList.forEach((slider, i) => {
      index !== i
        ? slider.classList.add("visually-hidden")
        : slider.classList.remove("visually-hidden");
    });

    this.navControlsList.forEach((nav, i) => {
      index !== i
        ? nav.classList.add("visually-hidden")
        : nav.classList.remove("visually-hidden");
    });
  }
}

if (!window.customElements.get("tabbed-collection-slider")) {
  window.customElements.define(
    "tabbed-collection-slider",
    TabbedCollectionSlider
  );
}
